import React, { useEffect, useState } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";

const Faqhead = () => {
  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/faq/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      <div
        class="col-xxl-8 col-xl-10 col-lg-10 col-md-10 col-sm-10 col-12"
      >
        <div class="card custom-card overflow-hidden">
          <div class="card-body p-0">
            <div class="faqs-page-banner flex align-items-center justify-content-center">
              <div class="text-center text-white">
                <h5 class="mb-1  fw-semibold text-primary">
                  {languageData.page.title}
                </h5>
                <h3 class="mb-1 fw-semibold text-fixed-white">
                  {languageData.page.sub_title}
                </h3>
                <p class="fs-15  op-8 text-fixed-white">
                  {languageData.page.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faqhead;
